module.exports = __webpack_public_path__ + "img/mac-screen-0.a4b17ab0.png";